

import __layout_0 from '/R:/Touhou-Vote/packages/result/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/R:/Touhou-Vote/packages/result/src/layouts/blank.vue'),
'default': __layout_0,
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
